import { Component, OnInit, Input } from '@angular/core';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-widget-image-block',
  templateUrl: './widget-image-block.component.html',
  styleUrls: ['./widget-image-block.component.scss'],
})
export class WidgetImageBlockComponent implements OnInit  {
  @Input() widgetID: any;
  @Input() widgetTitle: any;
  widgetData:any;
  widgetStyle:any;
  background:any ;
  constructor(private widgetsService:WidgetsService, private domSanitizer:DomSanitizer) { }

  ngOnInit() {
    this.initializeSubscriptions();
  }

  async initializeSubscriptions(){
    let widgetData:any = await this.widgetsService.getWidgetData(this.widgetID);
    // console.log('img data', data)
    if(widgetData){
      this.widgetData = widgetData;
      if (widgetData && widgetData.style && Object.keys(widgetData.style).length != 0) {
        this.widgetStyle = widgetData.style;
        if(this.widgetStyle.backgroundImage){
            this.background = this.domSanitizer.bypassSecurityTrustStyle(`url(${this.widgetStyle.backgroundImage})`);
        }
        else if(this.widgetStyle.backgroundColor){
            this.background = this.widgetStyle.backgroundColor;
        }
        else{
           // this.background = 'transparent';
        }
    }
    }
    console.log('app-widget-image-block background', this.background)
  }


}
